import CurrentFacilityContext, {
	type CurrentFacilityContextValue,
} from '@UI/Providers/CurrentFacilityProvider/CurrentFacilityContext';
import * as React from 'react';

function useCurrentFacility(): CurrentFacilityContextValue {
	const context = React.useContext(CurrentFacilityContext);

	if (context === null) {
		throw new Error('useCurrentFacility must be used within a CurrentFacilityProvider.');
	}

	return context;
}

export default useCurrentFacility;
